import React from 'react';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';

import inject from '../../hoc/injectHoc';
import {userPaymentRoute} from '../../routePaths';
import {replaceRouteParams} from '../../../utils/routeHelper';

/**
 * The UpgradeButton component.
 */
export class UpgradeButton extends React.Component {
  /**
   * Redirects to the sign up page.
   */
  onUpgrade = () => {
    const {routerStore} = this.props;

    const toRoute = replaceRouteParams(userPaymentRoute, {planId: ''});
    routerStore.push(userPaymentRoute, {
      addTo: toRoute,
    });
  };

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <button
        className="btn btn-secondary action-button save-button mb-3"
        type="button"
        onClick={this.onUpgrade}
      >Upgrade Plan To Use</button>
    );
  }
}

UpgradeButton.propTypes = {
  routerStore: MobxPropTypes.observableObject,
};

UpgradeButton.wrappedComponent = {};
UpgradeButton.wrappedComponent.propTypes = {
  routerStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(UpgradeButton)(
  observer(UpgradeButton)
);
